export default "__VITE_ASSET__C7fw20MQ__";